module.exports = __webpack_public_path__ + "img/c8.848e91b4.png";